import styled from "@emotion/styled";
import { Card, IconButton, Typography } from "@mui/material";

export const PresentationCardRoot = styled(Card)`
  position: relative;
  height: 100%;
  display: flex;
  flex-direction: column;
  cursor: pointer;
`;

export const CoverImageWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 140px;
  overflow: hidden;
`;

export const CoverImagePlaceholder = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${(p) => p.theme.colors.border2};
`;

export const CardMenuButton = styled.div`
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
`;

export const MenuIconButton = styled(IconButton)`
  background-color: ${(p) => p.theme.button.outlined.colors.background};
  color: ${(p) => p.theme.button.outlined.colors.text};

  &:hover {
    background-color: ${(p) => p.theme.button.outlined.hover.background};
    color: ${(p) => p.theme.button.outlined.hover.text};
  }
`;

export const CardTitle = styled(Typography)`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const CardSubtitle = styled(Typography)`
  margin-top: 0.125rem;
`;
